import { render, staticRenderFns } from "./ToolbarTitle.vue?vue&type=template&id=6500608b&scoped=true&"
import script from "./ToolbarTitle.vue?vue&type=script&lang=js&"
export * from "./ToolbarTitle.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarTitle.vue?vue&type=style&index=0&id=6500608b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6500608b",
  null
  
)

component.options.__file = "ToolbarTitle.vue"
export default component.exports